var _objectSpread = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread2");

var _assertThisInitialized = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/assertThisInitialized");

var _regeneratorRuntime = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _inherits = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

var _classCallCheck = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var AbstractBlackBox = /*#__PURE__*/function () {
  "use strict";

  function AbstractBlackBox() {
    _classCallCheck(this, AbstractBlackBox);

    this._name = this.constructor.name;
    this._loadStarted = false;
    this._loaded = false;
    this._unloaded = false;
    this._abortController = new AbortController();
  }

  _createClass(AbstractBlackBox, [{
    key: "guardedStore",
    value: function guardedStore(_ref) {
      var _this = this;

      var _dispatch = _ref.dispatch,
          getState = _ref.getState;

      if (!this._guardedStore) {
        this._guardedStore = {
          dispatch: function dispatch(action) {
            if (_this._unloaded) {
              throw new Error("This black box (".concat(_this._name, ") has been removed from the redux state: ") + "it can no longer dispatch an action (".concat(action.type, ")")); // basic cancellation
            }

            return _dispatch(action);
          },
          getState: getState,
          abortSignal: this._abortController.signal
        };
      }

      return this._guardedStore;
    }
  }, {
    key: "onLoadInternal",
    value: function onLoadInternal(store) {
      console.assert(!this._loadStarted, 'black box already loaded');
      this._loadStarted = true;
      this.onLoad(this.guardedStore(store));
      this._loaded = true;
    }
  }, {
    key: "onUnloadInternal",
    value: function onUnloadInternal(store) {
      console.assert(this._loaded, 'black box not yet loaded');
      console.assert(!this._unloaded, 'black box already unloaded');
      this._unloaded = true;

      this._abortController.abort();

      this.onUnload(this.guardedStore(store));
    }
  }, {
    key: "onActionInternal",
    value: function onActionInternal(action, store) {
      console.assert(this._loaded, 'black box not yet loaded');
      console.assert(!this._unloaded, 'black box already unloaded');
      this.onAction(action, this.guardedStore(store));
    }
  }, {
    key: "onLoad",
    value: function onLoad(_ref2) {
      var dispatch = _ref2.dispatch,
          getState = _ref2.getState;
      throw new Error('Not implemented');
    }
  }, {
    key: "onUnload",
    value: function onUnload(_ref3) {
      var getState = _ref3.getState;
      throw new Error('Not implemented');
    }
  }, {
    key: "onAction",
    value: function onAction(action, _ref4) {
      var dispatch = _ref4.dispatch,
          getState = _ref4.getState;
    }
  }]);

  return AbstractBlackBox;
}();

var PromiseBlackBox = /*#__PURE__*/function (_AbstractBlackBox) {
  "use strict";

  _inherits(PromiseBlackBox, _AbstractBlackBox);

  var _super = _createSuper(PromiseBlackBox);

  function PromiseBlackBox(promiseGenerator) {
    var _this2;

    _classCallCheck(this, PromiseBlackBox);

    _this2 = _super.call(this);
    _this2._resolved = false;
    _this2._promiseGenerator = promiseGenerator;
    return _this2;
  }

  _createClass(PromiseBlackBox, [{
    key: "onLoad",
    value: function () {
      var _onLoad = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref5) {
        var dispatch, abortSignal, action;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                dispatch = _ref5.dispatch, abortSignal = _ref5.abortSignal;
                _context.prev = 1;
                // call the promise generator: note that this function can return a non-standard promise with `.cancel()` method
                this._promise = this._promiseGenerator(abortSignal); // wait for it to finish

                _context.next = 5;
                return this._promise;

              case 5:
                action = _context.sent;
                this._resolved = true;
                _context.prev = 7;

                if (!(action && !this._unloaded)) {
                  _context.next = 10;
                  break;
                }

                return _context.abrupt("return", dispatch(action));

              case 10:
                _context.next = 16;
                break;

              case 12:
                _context.prev = 12;
                _context.t0 = _context["catch"](7);
                console.error("An error was thrown while dispatching an action: ".concat(_context.t0)); // console.error(e);

                throw _context.t0;

              case 16:
                _context.next = 23;
                break;

              case 18:
                _context.prev = 18;
                _context.t1 = _context["catch"](1);
                this._resolved = true;
                console.error("An error was thrown during execution of this black box (".concat(this._name, "): ").concat(_context.t1)); // console.error(e);

                throw _context.t1;

              case 23:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[1, 18], [7, 12]]);
      }));

      function onLoad(_x) {
        return _onLoad.apply(this, arguments);
      }

      return onLoad;
    }()
  }, {
    key: "onUnload",
    value: function onUnload() {
      if (!this._resolved && this._promise.cancel) this._promise.cancel();
    }
  }]);

  return PromiseBlackBox;
}(AbstractBlackBox);

var ReduxBlackBox = /*#__PURE__*/function (_AbstractBlackBox2) {
  "use strict";

  _inherits(ReduxBlackBox, _AbstractBlackBox2);

  var _super2 = _createSuper(ReduxBlackBox);

  function ReduxBlackBox(actionStart) {
    var _this3;

    var actionAfter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    var take = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {
      return true;
    };

    _classCallCheck(this, ReduxBlackBox);

    _this3 = _super2.call(this);
    console.assert(actionStart, 'A start action is required');
    _this3._finished = !actionAfter; // if no action after, no need to wait for anything

    _this3._actionStart = actionStart;
    _this3._actionAfter = actionAfter;
    _this3._take = take;
    return _this3;
  }

  _createClass(ReduxBlackBox, [{
    key: "onLoad",
    value: function () {
      var _onLoad2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref6) {
        var dispatch;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                dispatch = _ref6.dispatch;
                _context2.next = 3;
                return null;

              case 3:
                // force async dispatch
                if (!this._unloaded) dispatch(this._actionStart);

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function onLoad(_x2) {
        return _onLoad2.apply(this, arguments);
      }

      return onLoad;
    }()
  }, {
    key: "onUnload",
    value: function onUnload() {}
  }, {
    key: "onAction",
    value: function () {
      var _onAction = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(action, _ref7) {
        var dispatch, getState;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                dispatch = _ref7.dispatch, getState = _ref7.getState;

                if (!(this._finished || this._unloaded || !this._loaded)) {
                  _context3.next = 3;
                  break;
                }

                return _context3.abrupt("return");

              case 3:
                if (!this._take(action, getState())) {
                  _context3.next = 8;
                  break;
                }

                this._finished = true;
                _context3.next = 7;
                return null;

              case 7:
                // force async dispatch
                if (this._actionAfter instanceof Function) {
                  dispatch(this._actionAfter(action));
                } else {
                  dispatch(this._actionAfter);
                }

              case 8:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function onAction(_x3, _x4) {
        return _onAction.apply(this, arguments);
      }

      return onAction;
    }()
  }]);

  return ReduxBlackBox;
}(AbstractBlackBox);

var patternToFilter = function patternToFilter(pattern) {
  if (pattern === undefined || pattern === '*') return function () {
    return true;
  }; // wildcard matches all actions

  if (typeof pattern === 'function') return pattern; // pattern can be a function

  if (typeof pattern === 'string') return function (act) {
    return act.type === pattern;
  }; // string matches action.type
  // If pattern is an array, each item in the array is matched with aforementioned rules

  if (Array.isArray(pattern)) {
    var filterArray = pattern.map(patternToFilter);
    return function (act) {
      return filterArray.some(function (filter) {
        return filter(act);
      });
    };
  }

  throw new Error('take only accepts a function, wildcard, string or array as pattern');
};

var AsyncBlackBox = /*#__PURE__*/function (_AbstractBlackBox3) {
  "use strict";

  _inherits(AsyncBlackBox, _AbstractBlackBox3);

  var _super3 = _createSuper(AsyncBlackBox);

  function AsyncBlackBox(promiseGenerator) {
    var _this4;

    _classCallCheck(this, AsyncBlackBox);

    _this4 = _super3.call(this);
    _this4._name = promiseGenerator.name;
    _this4._resolved = false;
    _this4._promiseGenerator = promiseGenerator;
    _this4._takeFilters = [];
    _this4._take = _this4._take.bind(_assertThisInitialized(_this4));
    return _this4;
  }

  _createClass(AsyncBlackBox, [{
    key: "_take",
    value: function () {
      var _take2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(pattern) {
        var _this5 = this;

        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                return _context4.abrupt("return", new Promise(function (resolve) {
                  return _this5._takeFilters.push({
                    filter: patternToFilter(pattern),
                    resolve: resolve
                  });
                }));

              case 1:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      function _take(_x5) {
        return _take2.apply(this, arguments);
      }

      return _take;
    }()
  }, {
    key: "onLoad",
    value: function () {
      var _onLoad3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(store) {
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return null;

              case 2:
                if (!this._unloaded) {
                  _context5.next = 4;
                  break;
                }

                return _context5.abrupt("return");

              case 4:
                _context5.prev = 4;
                this._promise = this._promiseGenerator(_objectSpread(_objectSpread({}, store), {}, {
                  take: this._take
                }));
                if (this._unloaded && this._promise.cancel) this._promise.cancel();
                _context5.next = 9;
                return this._promise;

              case 9:
                this._resolved = true;
                _context5.next = 17;
                break;

              case 12:
                _context5.prev = 12;
                _context5.t0 = _context5["catch"](4);
                this._resolved = true;
                console.error("An error was thrown during execution of this black box (".concat(this._name, "): ").concat(_context5.t0)); // console.error(e);

                throw _context5.t0;

              case 17:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this, [[4, 12]]);
      }));

      function onLoad(_x6) {
        return _onLoad3.apply(this, arguments);
      }

      return onLoad;
    }()
  }, {
    key: "onAction",
    value: function onAction(action) {
      // matching takefilters
      var matchedFilters = this._takeFilters.filter(function (_ref8) {
        var filter = _ref8.filter;
        return filter(action);
      }); // remaining takefilters


      this._takeFilters = this._takeFilters.filter(function (takeFilter) {
        return !matchedFilters.includes(takeFilter);
      }); // resolve matching promises

      matchedFilters.forEach(function (_ref9) {
        var resolve = _ref9.resolve;
        return resolve(action);
      });
    }
  }, {
    key: "onUnload",
    value: function onUnload() {
      if (!this._resolved && this._promise && this._promise.cancel) this._promise.cancel();
    }
  }]);

  return AsyncBlackBox;
}(AbstractBlackBox);

function findBlackBoxesInObj(obj, ignoredPaths, subsystems) {
  if (obj instanceof AbstractBlackBox) {
    subsystems.push(obj);
  } else if (Array.isArray(obj)) {
    // eslint-disable-next-line no-use-before-define
    obj.forEach(function (child, key) {
      return recurseFindBlackBoxesInObj(key, child, ignoredPaths, subsystems);
    });
  } else if (typeof obj === 'object' && obj !== null) {
    // eslint-disable-next-line no-use-before-define
    Object.keys(obj).forEach(function (key) {
      return recurseFindBlackBoxesInObj(key, obj[key], ignoredPaths, subsystems);
    });
  }

  return subsystems;
}

function recurseFindBlackBoxesInObj(key, child, ignoredPaths, subsystems) {
  var newIgnoredPaths;

  if (ignoredPaths.length === 0) {
    newIgnoredPaths = ignoredPaths;
  } else {
    var isIgnoredPath = ignoredPaths.some(function (ignoredPath) {
      return ignoredPath.length === 1 && (ignoredPath[0] === key || ignoredPath[0] === '*');
    });
    if (isIgnoredPath) return;
    newIgnoredPaths = ignoredPaths.map(function (ignoredPath) {
      return ignoredPath.length > 1 && (ignoredPath[0] === key || ignoredPath[0] === '*') ? ignoredPath.slice(1) : null;
    }).filter(function (ignoredPath) {
      return ignoredPath !== null;
    });
  }

  findBlackBoxesInObj(child, newIgnoredPaths, subsystems);
}

function createBlackBoxMiddleware(ignoredPaths) {
  var ignoredPathArrays = ignoredPaths.map(function (p) {
    return Array.isArray(p) ? p : p.split('.');
  });
  return function blackBoxMiddleware(_ref10) {
    var dispatch = _ref10.dispatch,
        getState = _ref10.getState;
    var lock = false;
    var blackBoxesBefore = [];
    return function (next) {
      return function (action) {
        var returnValue = next(action);
        var blackBoxesAfter = findBlackBoxesInObj(getState(), ignoredPathArrays, []);
        var addedBlackBoxes = blackBoxesAfter.filter(function (blackBox) {
          return !blackBoxesBefore.includes(blackBox);
        });
        var removedBlackBoxes = blackBoxesBefore.filter(function (blackBox) {
          return !blackBoxesAfter.includes(blackBox);
        });
        blackBoxesBefore = blackBoxesAfter;

        try {
          if (lock) throw new Error('Black boxes may not synchronously dispatch actions.');
          lock = true;
          addedBlackBoxes.forEach(function (blackBox) {
            return blackBox.onLoadInternal({
              dispatch: dispatch,
              getState: getState
            });
          });
          removedBlackBoxes.forEach(function (blackBox) {
            return blackBox.onUnloadInternal({
              getState: getState
            });
          });
          blackBoxesAfter.forEach(function (blackBox) {
            return blackBox.onActionInternal(action, {
              dispatch: dispatch,
              getState: getState
            });
          });
        } catch (e) {
          console.error("Error occurred while processing action: ".concat(JSON.stringify(action)));
          console.error(e);
          throw new Error("Error occurred while processing action: ".concat(JSON.stringify(action)));
        } finally {
          lock = false;
        }

        return returnValue;
      };
    };
  };
}

var blackBoxMiddleware = createBlackBoxMiddleware([]);
module.exports = {
  AbstractBlackBox: AbstractBlackBox,
  PromiseBlackBox: PromiseBlackBox,
  ReduxBlackBox: ReduxBlackBox,
  AsyncBlackBox: AsyncBlackBox,
  blackBoxMiddleware: blackBoxMiddleware,
  createBlackBoxMiddleware: createBlackBoxMiddleware
};